<template>
  <div class="order-details">
    <van-cell-group :border="false">
      <van-cell title-class="order-status" :value="orderDetail.payed | money">
        <template #title>
          <span>订单金额</span>
          <van-tag
            v-if="orderStatusColor(orderDetail.status) !== ''"
            :color="orderStatusColor(orderDetail.status)"
          >
            {{ orderDetail.status | orderStatus }}
          </van-tag>
        </template>
      </van-cell>
      <van-cell title="订单号:" :value="orderDetail.orderNo" />
      <van-cell title="创建时间:" :value="orderDetail.created | dateFormat" />
      <van-cell title="创建人:" :value="orderDetail.operatorName || '--'" />
      <van-cell title="订单类型:" :value="orderDetail.orderType | orderType" />
      <van-cell
        title="订单内容:"
        :value="orderDetail.orderType | orderContent(orderDetail)"
      />
      <van-cell
        title="核销状态:"
        :value="orderDetail.writeOffStatus == 0 ? '未核销' : '已核销'"
      />
      <van-cell
        title="订单成交人:"
        :value="orderDetail.orderSubmitOwnerName || '--'"
      />
      <van-cell
        title="订单归属人:"
        :value="orderDetail.orderOwnerName || '--'"
      />
      <div class="table-divider">
        <van-divider />
      </div>
      <van-cell title="客户姓名:" class="btn">
        <template #extra>
          <span
            v-if="orderDetail.customerName"
            class="van-cell__value"
            @click="
              $router.push({
                name: 'CustomerDetails',
                query: { id: orderDetail.customerId },
              })
            "
          >
            {{ orderDetail.customerName }}({{orderDetail.customerTel}})
          </span>
          <span v-if="isCanAddCustomMobile==true" @click="addMobilePicker = true" class="van-cell__value"
            >填写手机号</span
          >
        </template>
      </van-cell>
      <van-cell
        title="客户归属人:"
        :value="orderDetail.customerparentName || '--'"
      />
      <van-cell title="机构:" class="btn">
        <template
          v-if="
            Array.isArray(orderDetail.customerOrg) &&
            orderDetail.customerOrg.length
          "
        >
          <p
            v-for="region in orderDetail.customerOrg"
            :key="region.id"
            @click="showRegion(region)"
          >
            {{ region.orgName }}
          </p>
        </template>
        <span v-else @click="addRegionPicker = true">未完善</span>
      </van-cell>
      <div class="table-divider">
        <van-divider />
      </div>
      <van-cell
        v-if="orderDetail.projectPrice"
        title="商品金额:"
        :value="orderDetail.projectPrice | money"
      />
      <van-cell title="订单金额:" :value="orderDetail.payed | money" />
      <van-cell
        v-if="orderDetail.updateShouldPayInfo"
        title="修改金额说明:"
        :value="orderDetail.updateShouldPayInfo"
      />
      <van-cell title="支付方式:" :value="orderDetail.payType | payType" />
      <van-cell title="支付凭证:" :value="orderDetail.tradeNo || '--'" />
      <van-row v-if="orderDetail.image" class="img-wrap">
        <!-- 多张图片 -->
        <van-col
          v-for="item in orderDetail.image.split(',')"
          :key="item"
          :span="6"
        >
          <ShowImage :url="item" />
        </van-col>
      </van-row>
      <div class="table-divider">
        <van-divider />
      </div>
      <van-cell title="收益状态" :value="profitStatusTxt" />
      <van-cell
        v-if="profit.status"
        title="业绩金额:"
        :value="profit.shouldPay | money"
      />
      <van-cell
        title="订单成交人:"
        :value="profit.orderSubmitOwner.adminName || '--'"
      />
      <van-cell
        v-if="profit.status"
        title="成交人提成:"
        :value="profit.orderSubmitOwner.remindMoney | money"
      />
      <van-cell
        title="订单归属人:"
        :value="profit.orderOwner.adminName || '--'"
      />
      <template v-if="profit.status">
        <van-cell
          title="归属人提成:"
          :value="profit.orderOwner.remindMoney | money"
        />
        <van-cell title="管理提成">
          <template #extra>
            <div v-if="profit.manageRemind">
              <p
                class="manage-remind"
                v-for="item in profit.manageRemind"
                :key="item.adminName"
              >
                {{ item.remindMoney | money
                }}{{ `(${item.adminName}-${item.StaffRulName})` }}
              </p>
            </div>
          </template>
        </van-cell>
        <van-cell
          title="修改时间"
          :value="profit.orderProfitUpdateLog.modified | dateFormat"
        />
        <van-cell
          title="修改人"
          :value="profit.orderProfitUpdateLog.operatorName || '--'"
        />
        <van-cell
          title="备注"
          :value="profit.orderProfitUpdateLog.remark || '--'"
        />
      </template>
      <!-- 订单审核 -->
      <div
        class="order-audit"
        v-if="orderDetail.orderVerify || $route.query.status === 'audit'"
      >
        <div class="sub-title">
          <span>订单审核</span>
        </div>
        <!-- 展示订单审核结果 -->
        <template
          v-if="orderDetail.orderVerify || $route.query.status !== 'audit'"
        >
          <van-cell
            title="审核时间:"
            :value="orderDetail.orderVerify.created | dateFormat"
          />
          <van-cell
            title="审核人:"
            :value="orderDetail.orderVerify.operatorName"
          />
          <van-cell
            title="审核结果:"
            :value="orderDetail.status | orderStatus"
          />
          <van-cell title="备注:" :value="orderDetail.orderVerify.remark" />
          <van-row class="img-wrap">
            <van-col
              v-for="item in orderDetail.orderVerify.content.split(',')"
              :key="item"
              :span="6"
            >
              <ShowImage :url="item" />
            </van-col>
          </van-row>
        </template>
        <!-- 提交订单审核 -->
        <van-form v-else @submit="submitAuditOrder">
          <van-field
            label="审核结果:"
            right-icon="arrow"
            clickable
            readonly
            :value="auditParams.status | auditStatus"
            :rules="[
              {
                required: true,
                message: '请选择审核结果',
                trigger: 'onChange',
              },
            ]"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              title="订单审核:"
              show-toolbar
              :columns="auditList"
              @cancel="showPicker = false"
              @confirm="handleConfirm"
            />
          </van-popup>
          <van-field
            label="备注:"
            v-model="auditParams.remark"
            placeholder="请输入备注"
            :rules="[{ required: true, message: '请填写备注' }]"
          />
          <van-field
            v-model="auditParams.content"
            label=""
            :rules="[{ required: true, message: '请上传审核凭证' }]"
          >
            <template #input>
              <UploadImage @uploadImage="auditParams.content = $event" />
            </template>
          </van-field>
          <div class="table-footer">
            <van-button
              v-if="$route.query.status === 'audit'"
              type="info"
              size="small"
              native-type="submit"
              >确定</van-button
            >
          </div>
        </van-form>
      </div>
      <!-- 小鹅通开课 -->
      <div
        v-if="orderDetail.source === 3 && orderDetail.status === 1"
        class="order-source"
      >
        <div class="sub-title">
          <span>小鹅通开课</span>
        </div>
        <van-cell
          title="同步状态："
          :value="xetSysInfo.synStatus === 1 ? '未同步' : '同步'"
        />
        <van-cell title="同步时间：" :value="xetSysInfo.synTime | dateFormat" />
        <van-cell title="用户ID：" :value="xetSysInfo.userId || '--'" />
        <van-cell title="用户手机号：">
          <template v-if="xetSysInfo.userTel">
            <a :href="`tel:${xetSysInfo.userTel}`">{{ xetSysInfo.userTel }}</a>
          </template>
          <span v-else>--</span>
        </van-cell>
        <van-cell title="同步商品：" :value="xetSysInfo.productName || '--'" />
      </div>
      <!-- 订单原始信息 -->
      <OrderSource v-if="orderDetail.source && orderDetail.source !== 1" />
    </van-cell-group>
    <!-- 机构信息 -->
    <Region
      v-if="visible === 'region'"
      pattern="edit"
      :visible="visible === 'region'"
      :value="regioInfo"
      @update:visible="visible = ''"
    />
    <!-- 添加机构 -->
    <AddRegion
      v-if="addRegionPicker"
      :visible.sync="addRegionPicker"
      :customerId="orderDetail.customerId"
      @addRegionSuccess="updateOrder"
    />

    <AddMobile
      v-if="addMobilePicker"
      :visible.sync="addMobilePicker"
      :orderId="orderDetail.id"
      @addMobileSuccess="updateOrder"
    />
  </div>
</template>

<script>
import { orderDetail as getOrderDetail, orderUpdate } from "@/api/order";
import { orderStatusColor, dateFormat } from "@/utils";
import UploadImage from "@/components/img/upload";
import ShowImage from "@/components/img/showImage";
import Region from "@/components/region";
import AddRegion from "@/components/region/selectRegion";
import AddMobile from "@/components/custom/addMobile";
import OrderSource from "./components/orderSource";
export default {
  name: "OrderDetails",
  components: {
    UploadImage,
    ShowImage,
    Region,
    OrderSource,
    AddRegion,
    AddMobile,
  },
  data() {
    return {
      showPicker: false,
      addRegionPicker: false,
      addMobilePicker: false,
      visible: "",
      auditList: [
        {
          text: "确认通过",
          value: 1,
        },
        {
          text: "订单驳回",
          value: 2,
        },
      ],
      orderDetail: {},
      auditParams: {
        // 订单审核参数
        id: Number(this.$route.query.id), // 订单id
        status: undefined,
        remark: "", // 备注
        content: "", // 支付凭证，多张图片以逗号分割
      },
      regioInfo: {
        orgNum: "",
        orgName: "",
        orgAddress: "",
        lng: undefined,
        lat: undefined,
      },
      profitStatusTxt: "",
      isCanAddCustomMobile: false,
    };
  },
  created() {
    this.getOrderDetail();
    var roleType = JSON.parse(localStorage.getItem("userInfo")).data.type;
    var roleId = JSON.parse(localStorage.getItem("userInfo")).data.roleId;

    if (roleType == 1) {
      //客服
      this.isCanAddCustomMobile = true;
    }

    //超管，财务，管理员
    if (roleId == 0 || roleId == 4 || roleId == 3) {
      this.isCanAddCustomMobile = true;
    }

  },
  computed: {
    profit() {
      // 收益信息
      const { profit: profitInfo } = this.orderDetail;
      const {
        orderSubmitOwner = {
          adminName: "--",
          remindMoney: 0,
        },
        orderOwner = {
          adminName: "--",
          remindMoney: 0,
        },
        manageRemind = [],
        orderProfitUpdateLog = {
          operatorName: "--",
          remark: "--",
          modified: "--",
        },
        shouldPay = 0,
        status = 0,
      } = profitInfo || {};
      return {
        orderSubmitOwner,
        orderOwner,
        manageRemind,
        orderProfitUpdateLog,
        shouldPay,
        status,
      };
    },
    xetSysInfo() {
      // 小鹅通同步信息
      return this.orderDetail.xetSysInfo || {};
    },
  },
  filters: {
    auditStatus(value) {
      switch (value) {
        case 1:
          return "确认通过";
        case 2:
          return "订单驳回";
        default:
          return "";
      }
    },
    dateFormat,
  },
  methods: {
    /**
     * 财务审核订单
     */
    submitAuditOrder() {
      console.log("订单审核", this.auditParams);
      orderUpdate(this.auditParams).then((res) => {
        if (res.errcode === 0) {
          this.getOrderDetail();
        }
      });
    },
    /**
     * 选中审核订单状态
     */
    handleConfirm(val) {
      this.auditParams.status = val.value;
      this.showPicker = false;
    },
    /**
     * 获取订单详情
     */
    getOrderDetail() {
      const { query } = this.$route;
      getOrderDetail({
        id: query.id ? parseInt(query.id) : undefined,
        orderNo: query.orderNo,
      }).then((res) => {
        if (res.errcode === 0) {
          this.orderDetail = res.data || {};
          if (this.orderDetail.profit.status == 1) {
            this.profitStatusTxt = "已计算";
          } else {
            this.profitStatusTxt = "未计算";
          }

          if (this.orderDetail.profit.deliverStatus == 1) {
            this.profitStatusTxt = this.profitStatusTxt + "(未购买交付课)";
          }
          if (this.orderDetail.profit.deliverStatus == 2) {
            this.profitStatusTxt = this.profitStatusTxt + "(交付课未核销)";
          }
          if (this.orderDetail.profit.deliverStatus == 3) {
            this.profitStatusTxt = this.profitStatusTxt + "(已交付)";
          }
        }
      });
    },
    orderStatusColor,
    showRegion(val) {
      this.visible = "region";
      const {
        orgNum = "",
        orgName = "",
        orgAddress = "",
        lng = undefined,
        lat = undefined,
      } = val;
      this.regioInfo = {
        orgNum,
        orgName,
        orgAddress,
        lng,
        lat,
      };
    },
    updateOrder() {
      // 更新订单信息
      this.getOrderDetail();
    },
  },
};
</script>

<style lang="less" scoped>
.order {
  &-details {
    padding-top: 15px;
    margin-bottom: 10px;

    .order-status {
      span {
        display: inline-block;
        vertical-align: top;
      }

      .van-tag {
        margin-left: 15px;
        margin-top: 3px;
      }
    }

    .van-cell {
      padding: 5px 16px;

      &::after {
        display: none;
      }
    }

    .btn {
      .van-cell__value {
        color: #0000ffc4;
      }
    }

    .manage-remind {
      text-align: right;
      color: #969799;
    }

    .van-icon-plus {
      font-size: 24px;
    }

    .sub-title {
      padding: 20px 0 10px 10px;
      font-size: 16px;
      color: #323233;
    }

    .table-divider {
      padding: 0 50px;
      margin: 10px 0;

      .van-divider {
        margin: 10px 0;
      }
    }

    .table-footer {
      background-color: #ebedf0;
      text-align: center;
      padding: 10px 0;

      .van-button {
        width: 130px;
      }
    }

    .img-wrap {
      padding: 0 16px;

      .van-col {
        padding-right: 10px;
      }
    }
  }

  &-audit {
    .sub-title {
      background-color: #ebedf0;
    }
  }
}
</style>
